import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase =
  supabaseUrl && supabaseAnonKey ? createClient(supabaseUrl, supabaseAnonKey) : null;

export function getSupabaseOrThrow() {
  if (!supabase) {
    throw new Error(
      'Supabase is niet geconfigureerd. Zet REACT_APP_SUPABASE_URL en REACT_APP_SUPABASE_ANON_KEY in je environment variables.'
    );
  }
  return supabase;
}
